import { createApp } from 'vue';
import { setErrorHandler } from '@/system/helpers/newRelic';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import router from '@/online_booking/new/router';
import vTooltip from '@/system/directives/tooltip';
import store from '@/online_booking/new/store';
import EventBus from '@/vendor/EventBus';
import globalFilters from '@/system/filters';
import { common as setup, setSharedVueCompilerOptions } from '@/system/build/common';
import OnlineBookingVueApp from '@/online_booking/new/OnlineBookingVueApp';

import '@/core/polyfills';
import registerGlobalComponents from '@/system/components/global';

// Nord design system components
import '@nordhealth/components';

dayjs.extend(utc)
dayjs.extend(timezone)


const app = createApp(OnlineBookingVueApp);
setSharedVueCompilerOptions(app);

app.component('video-player', () => import(/* webpackChunkName: 'video-player' */ 'App/components/apps/online_courses/VideoPlayer.vue'));
app.directive('tooltip', vTooltip);

// new global components
registerGlobalComponents(app);

setup(app);
setErrorHandler(app); // newrelic error handler
app.use(store);
app.use(router);
new EventBus(app);
app.use(globalFilters);

app.mount('#app');
